module.exports = __webpack_public_path__ + "static/media/logo-full.1a5a871b.svg";